import React, { useEffect } from 'react';
import Overlay from '../components/overlay/Overlay';
import NavLeftPublic from '../components/Navbar/public/NavLeftPublic';
import NavTopPublic from '../components/Navbar/public/NavTopPublic';

const PublicLayout = ({ children }) => {
  return (
    <>
      <div className="h-screen overflow-auto contenedor">
        <NavTopPublic />
        <Overlay />
        <NavLeftPublic />
        <div className="h-full flex md:ml-60 pt-14 text-gray-600 font-sans">{children}</div>
      </div>
    </>
  );
};

export default PublicLayout;
